import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import AuthApi from "../../api/authApi";
import ChangePassword from "./ChangePassword";
import ProfileDetails from "./ProfileDetails";
import { Cookies } from "react-cookie";

const MyProfile = () => {
  let cookies = new Cookies();
  let userData = cookies.get("LoveStrongUser") || null;
  let api = new AuthApi();
  const [userProfileData, setUserProfileData] = useState({});

  useEffect(() => {
    getProfileData();
  }, []);

  const getProfileData = async () => {
    await api
      .getProfile({ id: userData.id })
      .then((response) => {
        if (response.data) {
          setUserProfileData(response.data);
        }
      })
      .catch((error) => {
        toast.error(error.toString());
        console.error("There is an error!", error);
      });
  };

  return (
    <div className="settings">
      <div className="card ext-space">
        <div className="card-body">
          <p className="card-description">
            Here you can change password and emails.
          </p>
          {/* <ProfileDetails
            userProfileData={userProfileData}
            getProfileData={getProfileData}
          /> */}
          <ChangePassword
            userProfileData={userProfileData}
            getProfileData={getProfileData}
          />
        </div>
      </div>
    </div>
  );
};
export default MyProfile;
